export function ipfsToHTTP(image?: string): string {
    return image
        ? image.startsWith('ipfs')
            ? image.replaceAll('ipfs://', 'https://faktura.mypinata.cloud/ipfs/')
            : image
        : ''
}
